module.exports = "/_next/static/images/rizlabo_top-cbf7152ebb1f3dd665d4e00ef89cc3fa.jpg";